import { useState } from 'react'
import { SignedIn, SignedOut, SignIn } from '@clerk/clerk-react'
import Dashboard from './components/Dashboard'
import IncomeForm from './components/IncomeForm'
import ExpenseForm from './components/ExpenseForm'
import CategoryManager from './components/CategoryManager'
import SavingsGoals from './components/SavingsGoals'
import UserButton from './components/Auth/UserButton'

function App() {
  const [activeTab, setActiveTab] = useState('dashboard')

  return (
    <>
      {/* Show sign-in page if not authenticated */}
      <SignedOut>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
          <div className="w-full max-w-md">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-gray-900 mb-2">
                💰 Finance Tracker
              </h1>
              <p className="text-gray-600">
                Sign in to manage your personal finances
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-xl p-8">
              <SignIn 
                routing="hash"
                signUpUrl="#"
                afterSignInUrl="/"
                appearance={{
                  elements: {
                    rootBox: 'w-full',
                    card: 'shadow-none',
                  },
                }}
              />
            </div>
            
            <div className="text-center mt-6 text-sm text-gray-600">
              <p>Free forever • Secure • No credit card required</p>
            </div>
          </div>
        </div>
      </SignedOut>

      {/* Show app if authenticated */}
      <SignedIn>
        <div className="min-h-screen bg-gray-50">
          {/* Header */}
          <header className="bg-white shadow-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
              <div className="flex items-center justify-between">
                <h1 className="text-3xl font-bold text-gray-900">
                  💰 Finance Tracker
                </h1>
                <UserButton />
              </div>
            </div>
          </header>

          {/* Navigation */}
          <nav className="bg-white shadow-sm border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex space-x-8">
                {[
                  { id: 'dashboard', label: 'Dashboard', icon: '📊' },
                  { id: 'income', label: 'Income', icon: '💵' },
                  { id: 'expenses', label: 'Expenses', icon: '💸' },
                  { id: 'categories', label: 'Categories', icon: '🏷️' },
                  { id: 'goals', label: 'Savings Goals', icon: '🎯' },
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center space-x-2 py-4 px-3 border-b-2 font-medium text-sm transition-colors ${
                      activeTab === tab.id
                        ? 'border-primary-500 text-primary-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <span>{tab.icon}</span>
                    <span>{tab.label}</span>
                  </button>
                ))}
              </div>
            </div>
          </nav>

          {/* Main Content */}
          <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {activeTab === 'dashboard' && <Dashboard />}
            {activeTab === 'income' && <IncomeForm />}
            {activeTab === 'expenses' && <ExpenseForm />}
            {activeTab === 'categories' && <CategoryManager />}
            {activeTab === 'goals' && <SavingsGoals />}
          </main>
        </div>
      </SignedIn>
    </>
  )
}

export default App

